<template>
  <div></div>
</template>

<script>
export default {
  name: 'NezasaImportRedirect',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  created() {
    const rawId = this.$route.params.id || '';
    const sanitizedId = String(rawId).toLowerCase().replace(/\s/g, '');

    if (!/^[a-z0-9]{12}$/.test(sanitizedId)) {
      this.$router.replace('/404');
      return;
    }

    localStorage.setItem('nezasa_id_for_import', sanitizedId);
    localStorage.setItem('nezasa_autoimport', 'true');
    localStorage.setItem('nezasa_autoimport_date', String(Date.now()));

    if (this.options.user && this.options.user.loggedIn === true) {
      this.$router.replace('/trips');
    } else {
      this.$router.replace('/signin');
    }
  }
};
</script>
